import { Pipe, PipeTransform } from '@angular/core';

const valuesMap = {
  cm: 'cm',
  in: 'inch'
};

@Pipe({
  name: 'unitOfLengthAbbr'
})
export class UnitOfLengthAbbrPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return valuesMap[value];
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/pipes/unit-of-length-abbr.pipe.ts